import React from 'react';

import { observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import Field from 'bz-core-controls/controls/form/field/field';
import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import Button from 'bz-core-controls/controls/general/button';
import Checkbox from 'bz-core-controls/controls/general/checkbox';
import SecureSlideDialog from 'tm3-core/controls/modal/slide-dialog';

import { Text } from '@zinc/ui';
import { SlideDialogHeader } from 'bz-core-controls/controls/modal/slide-dialog/internal';
import ReportingFieldStore from './stores/reporting-field-store';
export interface IProps {
  onRequestClose: () => void;
  onSave?: () => void;
}

@observer
class AddReportingField extends React.Component<IProps> {
  store: ReportingFieldStore;

  constructor(props: IProps) {
    super(props);
    this.store = new ReportingFieldStore();
  }

  @bind
  async onSave() {
    let res = await this.store.save();
    if (res) {
      this.props.onSave?.();
      this.props.onRequestClose();
    }
  }

  @bind
  onCancel() {
    this.props.onRequestClose();
  }

  render() {
    const { bind } = this.store;

    return (
      <SecureSlideDialog
        header={
          <SlideDialogHeader
            heading="Add Reporting Field"
            actions={<Button key="add" onClick={this.onSave} label="Add" />}
          />
        }
        onClose={this.onCancel}
      >
        <div style={{ padding: '5px' }}>
          <Text variant="body-3" color="neutral-faded">
            Please specify the follow details to add the reporting field
          </Text>
          <FieldSelect
            label="Type"
            items={[{ name: 'Referral', value: 'R' }]}
            displayMember="name"
            valueMember="value"
            {...bind('objectType')}
          />
          <Field label="Display Name" liveOnChange={true} {...bind('displayName')} />
          (e.g. Name of Spouse)
          <Field label="Field Name" liveOnChange={true} {...bind('fieldName')} />
          (e.g. spouseName)
          <FieldSelect
            label="Type"
            items={[
              { name: 'Any', value: 'any' },
              { name: 'Text', value: 'string' },
              { name: 'Boolean', value: 'bool' },
              { name: 'Number', value: 'number' },
              { name: 'Date', value: 'date' }
            ]}
            displayMember="name"
            valueMember="value"
            {...bind('fieldType')}
          />
          <Checkbox
            label="Propagate"
            value={this.store.get('propagate')}
            onChange={() => this.store.set('propagate', !this.store.get('propagate'))}
          />
        </div>
      </SecureSlideDialog>
    );
  }
}

export default AddReportingField;
